import React, {Component} from "react";
import {
    Graphics, Sprite, Text, withPixiApp, Stage, Container, AnimatedSprite
} from "@inlet/react-pixi";
import {connect} from "react-redux";
import {IStore} from "../../../store/IStore";
import {Dispatch} from "redux";
import {actions as reelsActions} from "../../../reducers/reelsStateReducer";
import {actions as asyncActions} from "../../../reducers/asyncServerResponseReducer";
import {actions as winpresentationAction} from "../../../reducers/winPresentationReducer";
import {actions as soundActions} from "../../../reducers/soundReducer";


interface IProps {
    [x: string]: any;


}

interface IStateToProps {

    //reel_data: any,
    // currentBetIndex: number,
    // autoplayCount: number,
    // betList: Array<number>

}

interface IDispatchToProps {
    // startSpin:any;
    // stopSpin:any;

}

interface IState {
    selected: boolean

}

export class STARTBUTTONCODE extends Component<IProps, IState> {
    // protected app: PIXI.Application;
    constructor(props: IProps) {
        super(props);

    }

    shouldComponentUpdate(nextProps: Readonly<IProps>, nextState: Readonly<IState>, nextContext: any): boolean {


        return true;
    }


    componentDidMount() {


    }

    render() {

        let numberImage = "";

        let selected = this.props.defaultstate;

        if (selected) {
            numberImage = this.props.imgeOfButton[1];
        } else {
            numberImage = this.props.imgeOfButton[0];
        }

        return (<>
                <Sprite anchor={0.5} image={numberImage} x={this.props.buttonX} y={this.props.buttonY}
                        width={this.props.buttonWidth} height={this.props.buttonHeight}
                        interactive buttonMode
                        mouseup={() => {

                            this.props.beforeClick && this.props.beforeClick.call(this.props.scope);

                        }}
                />

            </>

        )
    }
}

